import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/concierge-bell.vue
var o = {
	name: "DtIconConciergeBell",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--concierge-bell"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Concierge Bell",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M11.5 9a1.5 1.5 0 0 0-1.02-1.421A4.5 4.5 0 0 0 6.5 3.528V2.5H7a.5.5 0 0 0 0-1H5a.5.5 0 0 0 0 1h.5v1.028a4.5 4.5 0 0 0-3.98 4.051A1.5 1.5 0 0 0 .5 9v1a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9ZM2 8.5a.5.5 0 0 0-.5.5v.5h9V9a.5.5 0 0 0-.5-.5H2Zm6.475-2.975A3.5 3.5 0 0 0 2.535 7.5h6.93a3.5 3.5 0 0 0-.99-1.975Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=concierge-bell.js.map